














































import Vue from "vue";
import Web3 from "web3";
import { AbiItem } from "web3-utils";
import UnicryptPresaleContractV4ABI from "../assets/UnicryptPresaleContractV4ABI.json";

export default Vue.extend({
  name: "UnicryptV4UserReserve2",

  data: () => ({
    web3: undefined as Web3 | undefined,
    connected: false as boolean,
    walletAddress: " " as string,
    balance: " " as string,
    targetContractAddress: "",
    hasAcquired: false as boolean,
    antiBotWait: 3 as number,
    startBlock: " " as string,
    contractOwner: " " as string,
    contractAddress: " " as string,
    reserveSecretKey: "0x9fb7b7c64ad435086a3846c1bdef385214256b36af0b9d4e017f18a19388119c" as string,
    generated: false as boolean,
    antiBotKey: " " as string,
    gasLimit: "1000000" as string,
    gasPrice: "5" as string,
    transactionResults: [] as Array<string>,
  }),
  methods: {
    async connect(): Promise<void> {
      const { ethereum } = window as any;
      if (!(ethereum /*&& ethereum.isMetaMask*/)) {
        alert("MetaMask がインストールされていません。");
      } else {
        const accounts = await ethereum.request({ method: "eth_requestAccounts" });
        this.web3 = new Web3(ethereum);
        const chainId = await this.web3.eth.getChainId();
        if (chainId != 56) {
          this.web3 = undefined;
          alert("BSC ネットワークで接続してください。");
        } else {
          ethereum.on("accountsChanged", () => {
            window.location.reload();
          });
          ethereum.on("chainChanged", () => {
            window.location.reload();
          });

          this.walletAddress = accounts[0];
          this.balance = Web3.utils.fromWei(await this.web3.eth.getBalance(this.walletAddress), "ether");
          this.connected = true;
        }
      }
    },
    async getPresaleInfo(): Promise<void> {
      if (this.web3 == null || !this.connected) {
        alert("MetaMask と接続してください。");
        return;
      }

      try {
        const unicryptPresaleContractV4Address = Web3.utils.toChecksumAddress(this.targetContractAddress);
        const unicryptPresaleContractV4ABI = UnicryptPresaleContractV4ABI as any as AbiItem;
        const unicryptPresaleContractV4 = new this.web3.eth.Contract(unicryptPresaleContractV4ABI, unicryptPresaleContractV4Address);

        this.hasAcquired = false;
        const result = await unicryptPresaleContractV4.methods["getInfo()"]().call();
        this.startBlock = result["4"]["8"];
        this.contractOwner = Web3.utils.toChecksumAddress(result["2"]["0"]);
        this.contractAddress = Web3.utils.toChecksumAddress(result["1"]["0"]);
        this.hasAcquired = true;
      } catch (error) {
        this.transactionResults.push(error);
      }
    },
    generateAntiBotKey(): void {
      if (this.web3 == null || !this.connected) {
        alert("MetaMask と接続してください。");
        return;
      }

      this.generated = false;
      const encodedParameters = this.web3.eth.abi.encodeParameters(
        ["address", "address", "address", "address", "bytes32"],
        [this.walletAddress, this.targetContractAddress, this.contractOwner, this.contractAddress, this.reserveSecretKey]
      );
      this.antiBotKey = Web3.utils.keccak256(encodedParameters);
      this.generated = true;
    },
    async click(): Promise<void> {
      if (this.web3 == null || !this.connected) {
        alert("MetaMask と接続してください。");
        return;
      }

      try {
        this.transactionResults.splice(0);

        const unicryptPresaleContractV4Address = Web3.utils.toChecksumAddress(this.targetContractAddress);
        const unicryptPresaleContractV4ABI = UnicryptPresaleContractV4ABI as any as AbiItem;
        const unicryptPresaleContractV4 = new this.web3.eth.Contract(unicryptPresaleContractV4ABI, unicryptPresaleContractV4Address);

        const data = unicryptPresaleContractV4.methods.reserveAllocationWithUNCL(this.antiBotKey).encodeABI();

        const nonce = await this.web3.eth.getTransactionCount(this.walletAddress);
        const transaction = {
          from: this.walletAddress,
          to: unicryptPresaleContractV4Address,
          data: data,
          gas: this.gasLimit,
          gasPrice: Web3.utils.toWei(this.gasPrice, "gwei"),
          nonce: nonce,
        };

        this.web3.eth
          .sendTransaction(transaction)
          .on("receipt", (receipt) => {
            const transactionStatus = receipt.status ? "Success" : "Failed";
            this.transactionResults.push(`transactionHash: ${receipt.transactionHash}, result: ${transactionStatus}`);
          })
          .on("error", (error) => {
            this.transactionResults.push(error.message);
          });
      } catch (error) {
        this.transactionResults.push(error);
      }
    },
  },
});
